<template>
	<el-form>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top">
					{{ translations.labels.widgetDuration }}
					<span :data-tooltip="translations.labels.tooltipWidgetDuration">
						<i class="el-icon-info" />
					</span>
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-input-number
					v-model="settings.duration"
					:step="0.5"
					:min="0.5"
					controls-position="right"
					style="width: 100%"
				/>
			</div>
		</div>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top required">
					{{ translations.labels.unitsMeasurement }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-select
					v-model="settings.units"
					:placeholder="translations.labels.selectUnit"
					class="wide"
				>
					<el-option
						v-for="(unit, index) in units"
						:key="index"
						:label="unit.label"
						:value="unit.id"
					/>
				</el-select>
			</div>
		</div>
		<div class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top required">
					{{ translations.labels.locationToUse }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-select
					v-model="settings.location"
					:placeholder="translations.labels.select"
					class="wide"
				>
					<el-option
						v-for="(location, index) in locationsToUse"
						:key="index"
						:label="location.label"
						:value="location.id"
					/>
				</el-select>
			</div>
		</div>
		<div v-if="settings.location === 'CUSTOM'" class="row middle margin-bottom-20">
			<div class="col-lg-4 col-sm-12">
				<label class="no-margin-top required">
					{{ translations.labels.location }}
				</label>
			</div>
			<div class="col-lg-8 col-sm-12">
				<el-autocomplete
					v-model="settings.formattedAddress"
					@select="selectItem"
					@clear="clearInput"
					:fetch-suggestions="ajaxSearch"
					:placeholder="translations.labels.enterLocation"
					:trigger-on-focus="false"
					prefix-icon="el-icon-search"
					clearable
				/>
			</div>
		</div>
		<div class="flex-end">
			<el-button
				@click="saveSettings()"
				:disabled="isDisabled"
				:type="isDisabled ? 'info' : 'primary'"
				plain
			>
				{{ translations.labels.saveChanges }}
			</el-button>
			<el-button
				@click="closeDialog()"
				plain
			>
				{{ translations.labels.cancel }}
			</el-button>
		</div>
	</el-form>
</template>

<script>
import { _getLocation } from '@/services/api/location'

import updateWidgetSettings from '@/services/mixins/updateWidgetSettings'

export default {
    name: 'WidgetSettings',
	props: {
		widget: Object
	},
	mixins: [
		updateWidgetSettings
	],
    data () {
        return {
			timeout:  null,
			settings: {},
			searchResults: [],
			units: [
				{
					id: 'METRIC',
					label: 'Metric (Celsius)'
				},
				{
					id: 'IMPERIAL',
					label: 'Imperial (Fahrenheit)'
				},
				{
					id: 'STANDARD',
					label: 'Standard (Kelvin)'
				}
			],
			locationsToUse: [
				{
					id: 'DEVICE',
					label: 'Device'
				},
				{
					id: 'CUSTOM',
					label: 'Custom'
				}
			]
        }
    },
	computed: {
		isDisabled () {
			return this.settings.units === null || this.settings.location === null || (this.settings.location === 'CUSTOM' ? !this.settings.formattedAddress : false)
		}
	},
	watch: {
		'widget': {
			handler () {
				const defaultSettings = {
					units: 'METRIC',
					location: null,
					latitude: null,
					longitude: null,
					formattedAddress: '',
					duration: 2
				}
				this.settings = this.objectLength(this.widget.settings) ? this.clone(this.widget.settings) : defaultSettings
			},
			immediate: true
		},
		'settings.location' () {
			if (this.settings.location === 'DEVICE') {
				this.settings.formattedAddress = null
				this.settings.latitude = null
				this.settings.longitude = null
			}
		}
	},
	methods: {
		ajaxSearch (query, cb) {
			_getLocation(query)
				.then(response => {
					this.searchResults = response
					let temp = []
					response.data.forEach(item => {
						temp.push({
							value: item.formattedAddress,
							id: item.id
						})
					})
					clearTimeout(this.timeout)
					this.timeout = setTimeout(() => cb(temp), 1000)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage(this.translations.labels.fail, this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
					}, 200)
				})
		},
		selectItem(temp) {
			const element = this.searchResults.find(item => item.id = temp.id)
			this.settings.latitude = element.latitude
			this.settings.longitude = element.longitude
		},
		clearInput () {
			this.search = null
			this.settings.latitude = null
			this.settings.longitude = null
		}
    }
}
</script>
